import ChatsDatabase from "pages/Admin/ChatsDatabase";

export default function ChatsDatabasePage() {
  return <ChatsDatabase />;
}
